<template>
    <div>
        <header-portrate />
        <div style="margin-bottom:70px;">
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;margin-top:100px !important;`">
                <v-col cols="12">
                    <h3>{{ lang.visit_request }} — {{ lang.service_requests_queue }}</h3>
                </v-col>
                <v-col cols="12" md="3" sm="12">
                    <label>{{ lang.status }}</label>
                    <b-form-select class="inborder" v-model="filterStatus" :options="statusOptions" @change="getRequests" />
                </v-col>
            </v-row>
            <v-row class="mainrow m-2" :style="`direction:`+lang.dir+`;`">
                <v-col cols="12">
                    <v-data-table
                        :headers="headers"
                        :items="rows"
                        :items-per-page="-1"
                        class="elevation-1"
                        hide-default-footer
                        fixed-header
                        :loading="loading"
                    >
                        <template v-slot:item="row">
                            <tr>
                                <td style="text-align:center;">{{ row.item.customer_name }}</td>
                                <td style="text-align:center;white-space:nowrap;">{{ row.item.date }}<span v-if="row.item.time"> {{ row.item.time }}</span></td>
                                <td style="max-width:300px;white-space:normal;">{{ row.item.note }}</td>
                                <td style="text-align:center;">
                                    <span :style="statusStyle(row.item.status)">{{ statusLabel(row.item.status) }}</span>
                                </td>
                                <td style="text-align:center;white-space:nowrap;">
                                    <template v-if="row.item.status === 'pending'">
                                        <b-button size="sm" variant="success" class="mr-1" @click="decide(row.item.id,'confirmed')">{{ lang.confirm }}</b-button>
                                        <b-button size="sm" variant="danger" @click="decide(row.item.id,'rejected')">{{ lang.reject }}</b-button>
                                    </template>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </div>
        <Footer />
    </div>
</template>

<script>
import HeaderPortrate from '@/components/Header-Portrate.vue'
import Footer from '@/components/Footer.vue'
import axios from 'axios'
export default{
    components: { HeaderPortrate, Footer },
    data() {
        return {
            rows: [],
            loading: false,
            filterStatus: 'pending',
        }
    },
    computed: {
        lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki) == 'en'){
                    return this.$store.state.lang.en;
                }else if(this.$cookies.get(this.$store.state.LangCooki) == 'ur'){
                    return this.$store.state.lang.ur;
                }else{
                    return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }
            else if(this.$store.state.deflang == 'ur'){
                return this.$store.state.lang.ur;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        statusOptions(){
            return [
                { value: 'pending', text: this.lang.pending },
                { value: 'confirmed', text: this.lang.confirmed },
                { value: 'rejected', text: this.lang.rejected },
                { value: '', text: this.lang.all },
            ];
        },
        headers(){
            return [
                { text: this.lang.customer_name, value: 'customer_name', sortable: false },
                { text: this.lang.request_date, value: 'date', sortable: false },
                { text: this.lang.request_note, value: 'note', sortable: false },
                { text: this.lang.status, value: 'status', sortable: false },
                { text: this.lang.action, value: 'actions', sortable: false },
            ];
        },
    },
    methods: {
        getRequests(){
            this.loading = true;
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'getServiceRequests');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[status]', this.filterStatus);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((res) => {
                this.loading = false;
                if(res.data.error && res.data.error.number === 200){
                    this.rows = res.data.results;
                }
            }).catch(() => { this.loading = false; });
        },
        decide(id, decision){
            const post = new FormData();
            post.append('defBranch', localStorage.getItem('defBranch'));
            post.append('financeYear', localStorage.getItem('financeYear'));
            post.append('type', 'decideServiceRequest');
            post.append('auth', this.$cookies.get(this.$store.state.COOKIEPhase));
            post.append('data[request_id]', id);
            post.append('data[decision]', decision);
            axios.post(this.$store.state.SAMCOTEC.r_path, post).then((res) => {
                if(res.data.error && res.data.error.number === 200){
                    this.getRequests();
                }
            });
        },
        statusLabel(status){
            const map = { pending: this.lang.pending, confirmed: this.lang.confirmed, rejected: this.lang.rejected };
            return map[status] || status;
        },
        statusStyle(status){
            const colors = { pending: '#f9a825', confirmed: '#2e7d32', rejected: '#c62828' };
            return `background:${colors[status] || '#888'};color:#fff;padding:2px 10px;border-radius:10px;font-size:.75rem;`;
        },
    },
    created(){
        this.getRequests();
    },
}
</script>
